import {
  type DeviceIdentifier,
  DeviceIdentifierTypeEnum,
  type PublicRequestReturnLabelFormValues,
  type SubmitReturnLabelDevice,
  type SubmitReturnLabelPayload,
  UserIdentifierTypeEnum,
} from './PublicRequestReturnLabel.types'

export const countDeviceIdentifiers = (devices: DeviceIdentifier[]): number =>
  devices.reduce((total, device) => {
    if (!device.value.trim()) {
      return total
    }

    const commaValues = device.value
      .split(',')
      .map(v => v.trim())
      .filter(Boolean)

    return total + commaValues.length
  }, 0)

const mapIdentifierType = (
  type: DeviceIdentifierTypeEnum,
): UserIdentifierTypeEnum => {
  switch (type) {
    case DeviceIdentifierTypeEnum.IMEI:
      return UserIdentifierTypeEnum.IMEI_SN
    case DeviceIdentifierTypeEnum.ORDER_ID:
      return UserIdentifierTypeEnum.ORDER_ID
    case DeviceIdentifierTypeEnum.RETURN_CASE_ID:
      return UserIdentifierTypeEnum.RETURN_CASE_ID
  }
}

const GERMANY_COUNTRY_CODE = 'DE'

export const buildSubmitPayload = (
  formValues: PublicRequestReturnLabelFormValues,
  requestToken: string,
): SubmitReturnLabelPayload => {
  const filledDevices: SubmitReturnLabelDevice[] = formValues.devices
    .filter(d => d.value.trim().length > 0)
    .map(d => ({
      user_identifier: d.value.trim(),
      user_identifier_type: mapIdentifierType(d.identifierType),
    }))

  const isNonGerman =
    !!formValues.country?.value &&
    formValues.country.value !== GERMANY_COUNTRY_CODE

  return {
    company_name: formValues.companyName,
    devices: filledDevices,
    email_address: formValues.contactEmail,
    full_name: formValues.contactName,
    sender_address: {
      city: formValues.city,
      country_code: formValues.country?.value ?? '',
      email_address: isNonGerman ? (formValues.senderEmail || null) : null,
      full_name: formValues.senderName,
      phone_number: isNonGerman ? (formValues.senderPhone || null) : null,
      postal_code: formValues.zipcode,
      street_address: formValues.street,
      street_number: formValues.streetNumber,
    },
    token: requestToken,
  }
}
